<div class="vc-modal__innerContainer i18nChoices__modalContent">
  <button aria-label="close modal" class="vc-modal__closeBtn" [mat-dialog-close]>
    <span class="vc-modal__closeBtn__crossLeft"></span> <span class="vc-modal__closeBtn__crossRight"></span>
  </button>
  <div class="vc-modal__title" i18n="@@PRODUCT.DETAILS.CONTROL_QUALITY.KNOW_MORE_MODAL.TITLE">
    Authenticity & Quality control
  </div>
  <div class="vc-modal__content" i18n="@@PRODUCT.DETAILS.CONTROL_QUALITY.KNOW_MORE_MODAL.CONTENT">
    <p>
      On Vestiaire Collective, each item sold with control and authentication fees is physically checked by our expert
      teams. They verify: <br />
      - the item’s authenticity and quality <br />
      - that the item matches the seller’s description <br />
      - that the item’s condition matches the seller’s stated condition <br />
      <br />
      Vestiaire Collective has no association and/or affiliation with the brands whose products are offered for sale on
      its website/App. <br />
      <br />
      The authentication of said products is performed independently by Vestiaire Collective. <br />
      <br />
      However, if the Direct Shipping option is available, the item can be sent directly to your delivery address
      without being checked by Vestiaire Collective. Once your parcel has been received, you have up to 72 hours to flag
      any conformity issues.
    </p>
  </div>
</div>
